import initLightbox from './components/lightbox';
import initProjectSplash from './components/projects/splash';
import initFlexCarousels from './components/flex-carousels';
import initFlexFeatured from './components/flex-featured';

const lightboxEl = document.querySelector('.js-lightbox');
const lightboxToggles = document.querySelectorAll('.js-lightbox-toggle');

if (lightboxEl && (lightboxToggles && lightboxToggles.length > 0)) {
    initLightbox(lightboxEl, lightboxToggles);
}

const projectSplash = document.querySelector('.js-project-splash');

if (projectSplash) {
    initProjectSplash(projectSplash);
}

const flexCarousels = document.querySelectorAll('.js-flex-carousel');

if (flexCarousels) {
    initFlexCarousels(flexCarousels);
}

const flexFeatured = document.querySelectorAll('.js-flex-featured');

if (flexFeatured) {
    initFlexFeatured(flexFeatured);
}
